// Declaration to extend the Window object
declare global {
    interface Window {
      RUNTIME_CONFIG: RuntimeConfig;
    }
  }
  
  export interface RuntimeConfig {
    DNS_BASE: string;
    AUTH_PROXY_URL?: string;
    OAUTH_PROVIDER_URL?: string;
    OIDC_CLIENT_ID?: string;
    OIDC_SCOPES?: string;
    API_BASE?: string;
    MQTT_URI?: string;
    INFLUX_URL?: string;
    ADMINER_URL?: string;
    GRAFANA_URL?: string;
    REDIS_URL?: string;
    DOCUMENTATION_URL?: string;
  }
  

  export const getRuntimeConfig = (): RuntimeConfig => {
    // Check if configuration is available
    if (!window.RUNTIME_CONFIG) {
      throw new Error('Runtime configuration is not loaded');
    }
    return window.RUNTIME_CONFIG;
  };
  
  export default getRuntimeConfig;